import React, { useEffect } from 'react'
import { getOptimizedImageUrl } from '../lib/cms'

export default function ImageLightbox({ images = [], currentIndex = 0, isOpen, onClose, onPrev, onNext }) {
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') onPrev()
      if (e.key === 'ArrowRight') onNext()
    }

    window.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden'

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose, onPrev, onNext])

  if (!isOpen || images.length === 0) return null

  const currentImage = images[currentIndex] || images[0]

  return (
    <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-200">
      {/* Backdrop click to close */}
      <div className="absolute inset-0" onClick={onClose} />

      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 p-3 text-slate-300 hover:text-white bg-slate-900/80 hover:bg-slate-800 rounded-full transition-colors focus:outline-none"
        aria-label="Luk visning"
      >
        <i className="fa-solid fa-xmark text-xl" aria-hidden="true" />
      </button>

      {/* Main Image Container */}
      <div className="relative z-10 max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
        <img
          src={getOptimizedImageUrl(currentImage.url || currentImage, 1600, 85)}
          alt={currentImage.alt || 'Billede fra SKI & CO TRAVEL'}
          className="max-w-full max-h-[75vh] object-contain rounded-xl shadow-2xl border border-slate-800"
        />

        {/* Caption & Counter */}
        <div className="mt-4 text-center">
          {currentImage.caption && (
            <p className="text-slate-200 text-sm font-medium mb-1">
              {currentImage.caption}
            </p>
          )}
          <p className="text-slate-400 text-xs font-mono">
            {currentIndex + 1} / {images.length}
          </p>
        </div>
      </div>

      {/* Navigation Buttons */}
      {images.length > 1 && (
        <>
          <button
            onClick={onPrev}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-50 p-3 text-slate-200 hover:text-white bg-slate-900/80 hover:bg-slate-800 rounded-full transition-colors focus:outline-none"
            aria-label="Forrige billede"
          >
            <i className="fa-solid fa-chevron-left text-xl" aria-hidden="true" />
          </button>
          <button
            onClick={onNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-50 p-3 text-slate-200 hover:text-white bg-slate-900/80 hover:bg-slate-800 rounded-full transition-colors focus:outline-none"
            aria-label="Næste billede"
          >
            <i className="fa-solid fa-chevron-right text-xl" aria-hidden="true" />
          </button>
        </>
      )}
    </div>
  )
}
